// i18n area 'storage' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.et-EE.meta.json.
import type { enUS } from './storage'

export const etEE: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Loo storage',
      path: 'Tee',
      pathHint: 'Absoluutne tee lubatud juurkataloogi all (vaikimisi /var/lib/tvirt/pools/)',
      shared: 'Jagatud storage',
      sharedChip: 'jagatud',
      sharedVerifiedChip: 'jagatud · kontrollitud',
      sharedVerifiedTooltip: 'Jagamine on kontrollitud: ristsondid kinnitavad, et iga liige näeb teiste kirjutatud andmeid.',
      sharedDisputedChip: 'jagatud · KONTROLLIMATA',
      sharedDisputedTooltip: 'Jagamine EI OLE kontrollitud',
      sharedDisputedPair: '{observer} ei näe andmeid, mille kirjutas {writer}',
      sharedHint: 'Võrgujagu, mis on igal liikmel kohalikult haagitud samale teele — live-migratsiooni eeltingimus (deklaratiivne).',
      sharedDanger: 'OHT — TVirt USUB seda lippu: selle sisselülitamisel eeldab iga liige, et näeb sellel teel SAMU baite. Kaustal, mis EI ole tõeliselt jagatud share (NFS/CIFS/klastri failisüsteem), on tulemuseks andmete riknemine ja kadu juba esimesel migratsioonil või esimesel HA-taaskäivitusel teisel sõlmel. Lülita see sisse ainult siis, kui tee on igal sõlmel identselt haagitud share.',
      type: 'Tüüp',
      capacity: 'Maht',
      provisioned: 'Eraldatud',
      provisionedOvercommit: 'Potentsiaalne kohustus üle mahu: thin-köited võivad kasvada kuni {n} GiB.',
      phase: { ready: 'Valmis', degraded: 'Halvenenud', error: 'Viga' },

      // Ring #156 (standarddialoog): TÄIELIK üksikasjade dialoog — sakid,
      // draiveripõhised seadistusread ja vaadeldud pind.
      tabConfig: 'Seadistus',
      tabCapacity: 'Maht ja olek',
      cardIdentity: 'Identiteet',
      cardPlacement: 'Paiknemine',
      cardConnection: 'Ühendus',
      usedReal: 'Tegelik hõive',
      capacityUnknown: 'Sõlm ei ole selle kogumi mahtu veel raporteerinud — siin numbreid välja ei mõelda',
      overcommitHint: 'Kohustus üle mahu: thin-kogumitel õiguspärane, hoia tegelikul hõivel silm peal',
      supportedContent: 'Toetatud sisu',
      content: {
        disks: 'Kettad',
        catalogFiles: 'Kataloogifailid',
        backups: 'Varundused',
        appVolumes: 'Rakenduste köited'
      },
      defaultDiskFormat: 'Ketta vaikevorming',
      reserveGiB: 'Reserveeritud vaba ruum (GiB)',
      available: 'Saadaval',
      diskCount: 'Kettad',
      filesystem: 'Failisüsteem',
      observedAt: 'Vaadeldud',
      lostAtRow: 'Kaotatuks kuulutatud',
      sharedProbeRow: 'Jagamise kontroll',
      sharedProbeNodes: 'Sonditud sõlmed',
      reachableFrom: 'Deklareeritud kättesaadavus',
      reachableFromHint: 'Sõlmed, kust see storage peab kättesaadav olema. VM, mille kettad, ISO-d või metaandmed on siin, ei käivitu ega migreeru sõlmele, keda selles loendis ei ole. Kõik liikmed on eelvalitud: kitsenda nii nagu soovid. Sõlm, kes liitub klastriga hiljem, jääb välja seni, kuni ta siia lisatakse.',
      reachableFromNone: 'deklareerimata',
      reachableFromTags: 'Kättesaadavus siltide järgi',
      reachableFromTagsHint: 'Selektor silt=väärtus (kirjed komadega eraldatuna, JA-loogikaga): iga liige, kes kannab neid silte, on deklareeritud kättesaadavaks — dünaamiliselt: sõlme sildistamine toob ta sisse.',
      reachableFromTagsInvalid: 'Vigane vorming — kasuta silt=väärtus, komadega eraldatuna',
      reachableResolved: 'Lahendatud sõlmed: {nodes}',
      reachableDeclaredNotSeen: 'deklareeritud, kuid jagamise sond ei näinud neil sõlmedel: {nodes}',
      reachableSeenNotDeclared: 'nähtud, kuid deklareerimata (väljaspool perimeetrit) neil sõlmedel: {nodes}',
      cephCluster: 'Hallatav Ceph-klaster',
      appGuardTitle: 'Rakenduste kasutuses olev storage',
      appEphemeralGuard: 'see storage on rakenduste klastriülene ajutine kogum — muuda seda enne rakenduste lehelt, seejärel kustuta.',
      appInUseGuard: 'siin elavad rakenduste rootid ja köited: {apps} — teisalda või kustuta need enne.',
      releaseRequiredTitle: "Kas kustutada '{name}' ja vabastada selle tõmmised?",
      releaseRequiredBatchTitle: "Kas kustutada valitud storage'id ja vabastada nende tõmmised?",
      releaseRequiredBody: "Tõmmiste vabastamine ei kustuta ÜHTEGI baiti: registrist eemaldamine jätab namespace'i kettale, tõmmised lihtsalt ei ole enam materialiseeritud ja iga scope'i viide jääb alles claim'ina — registreeri pool uuesti ja need adopteeritakse tagasi.",
      releaseConfirm: 'Kustuta ja vabasta tõmmised'
    },
    lost: {
      chip: 'Kaotatud',
      action: 'Kuuluta kaotatuks',
      confirmTitle: 'Kuuluta storage kaotatuks',
      confirmBody: "Operaatori kinnitus omal deklareeritud vastutusel: iga järjekorras või pooleli olev task sellel storage'il või selle objektidel EBAÕNNESTUB, kustutamised jäävad ainult registri tasandile (failisüsteemis tööd ei tehta) ja uus füüsiline töö lükatakse tagasi. Baite ei puudutata kunagi — kui köide ärkab ellu, registreeri see uuesti ja käivita skannimine, et kõik tagasi adopteerida.",
      confirmSubmit: 'Kuuluta kaotatuks',
      error: 'Kinnitus lükati tagasi'
    },
    findings: {
      action: 'Leitud objektid',
      title: 'Leitud objektid',
      empty: "Storage'i nimeruumist ei leitud ühtegi objekti",
      loadError: 'Leitud objekte ei õnnestunud laadida',
      actionError: 'Otsus lükati tagasi',
      colKind: 'Tüüp',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'See kataloog oli juba teise salvestusruumi poolt lähtestatud: identiteedipitser on üle kirjutatud selle salvestusruumi omaga. Sisu EI ole puudutatud — vaata allpool leitud objekte, impordi vajalikud ja seejärel sulge see teade.',
      kind: {
        disk: 'Ketas',
        catalogFile: 'Kataloogifail',
        vmMetadata: 'VM-i metaandmed',
        namespace: 'Nimeruum',
        foreign: 'Võõras',
        volumeGroup: 'Köitegrupp'
      },
      vgAdopt: {
        action: 'Adopteeri köitegrupp',
        title: 'Adopteeri köitegrupp',
        intro:
          'Sellel seadmel on juba köitegrupp TVirti nimega, kuid selle pitser ei nimeta ühtegi siia registreeritud storage\'it. See võib olla see, mille SELLE klastri varasem storage LUN-ile jättis, või see, mille TEINE TVirti klaster jättis LUN-ile, mis on omanikku vahetanud: siit paistavad mõlemad juhtumid ühesugused, ja seepärast ei otsusta keegi sinu eest.',
        irreversible: 'Vaata seadet, pitserit ja nime enne jätkamist: adopteerimist ei saa tagasi võtta.',
        device: 'Seade',
        seal: 'Pitser',
        sealNone: 'puudub (tvirt.storageId silti pole)',
        renameTo: 'Nimetatakse ümber',
        renameNone: 'Ümbernimetamist ei toimu: nimi on juba see, mille see storage tuletab',
        volumesNote:
          'Selles olevaid köiteid see žest EI adopteeri: järgmine skannimine pakub neid ükshaaval, tavaliste leitud objektidena.'
      },
      conflictChip: 'ID on juba olemas',
      dismissedChip: 'Eiratud',
      adopt: 'Adopteeri',
      adoptFileTitle: 'Impordi kataloogi',
      adoptFileHint: 'Failid eksisteerivad ainult kataloogide sees: vali leitud failile sihtkataloog.',
      purge: 'Kustuta kettalt',
      dismiss: 'Eira',
      purgeConfirmTitle: 'Kustuta kettalt',
      purgeConfirmBody: "{id} leitud baidid eemaldatakse storage'ist. Tegevus ei ole tagasipööratav.",
      taskStarted: 'Käivitatud — jätkub taustal taskina',
      scan: "Skanni storage'it",
      scanStarted: 'Skannimine käivitatud…',
      scanDone: 'Skannimine lõpetatud — leitud objektid on värskendatud'
    },
    reinit: {
      action: 'Proovi initsialiseerimist uuesti'
    },
    wizard: {
      addButton: 'Lisa',
      title: 'Lisa storage',
      back: 'Tagasi',
      continue: 'Edasi',
      selectHint: 'Vali protokoll, et näha, kuidas TVirt seda kasutab.',
      roadmap: 'Teekaart',
      server: 'Server',
      export: 'Eksporditud tee',
      share: 'Share',
      username: 'Kasutajanimi',
      password: 'Parool',
      passwordHint: 'Ainult kirjutamiseks: kasutatakse haakimisel, rohkem seda ei näidata.',
      credential: 'Mandaat',
      credentialManual: 'Sisesta käsitsi',
      credentialHint: "Kasutajanime ja parooli tüüpi keystore'i kirje — alternatiiv nende siia trükkimisele.",
      credentialEmpty: "Keystore'is ei ole ühtegi kasutajanime ja parooli tüüpi mandaati — loo see Süsteem → Mandaadid all või trüki konto siia alla.",
      options: 'Haakimise valikud',
      optionsHint: 'Komadega eraldatuna, antakse mount -o käsule sellisena, nagu on.',
      portal: 'Portal',
      portalHint: 'host[:port] — vaikimisi port on 3260.',
      target: 'Target IQN',
      targetHint: 'iSCSI targeti nimi, algab iqn-iga.',
      lun: 'LUN',
      wholeLunRow: 'Ketastel: see salvestusruum nimetab ainult sihtmärki',
      wholeLunHint: 'See salvestusruum nimetab ainult sihtmärki: tema LUN-id saavad ketasteks ükshaaval (Loo ketas → võta üle terve LUN), sihtmärgile ei kirjutata midagi.',
      lunHint: 'LUN-i number targetil — kahtluse korral 0.',
      chapCredential: 'Mandaat (CHAP)',
      chapCredentialHint: "CHAP (iSCSI) tüüpi keystore'i kirje, mida kasutatakse sisselogimisel — saladus ei rända kunagi storage'iga kaasa.",
      chapNone: 'Autentimiseta',
      chapEmpty: "Keystore'is ei ole ühtegi CHAP (iSCSI) tüüpi mandaati — loo see Süsteem → Mandaadid all. Ilma selleta jääb sisselogimine autentimata.",
      address: 'Aadress',
      addressHint: 'NVMe/TCP targeti host või IP (traddr).',
      port: 'Port',
      portHint: 'Targeti TCP-port — tühjaks jäetuna 4420.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Targeti alamsüsteemi NQN, algab nqn-iga.',
      nsid: 'NSID',
      nsidHint: 'Nimeruumi ID alamsüsteemi sees — kahtluse korral 1.',
      dhchapCredential: 'Mandaat (DH-HMAC-CHAP)',
      dhchapCredentialHint: "DH-HMAC-CHAP (NVMe) tüüpi keystore'i kirje, mida kasutatakse ühendumisel — saladus ei rända kunagi storage'iga kaasa.",
      dhchapNone: 'Autentimiseta',
      dhchapEmpty: "Keystore'is ei ole ühtegi DH-HMAC-CHAP (NVMe) tüüpi mandaati — loo see Süsteem → Mandaadid all. Ilma selleta jääb ühendus autentimata.",
      monitors: 'Monitorid',
      monitorsHint: 'Ceph-i monitoride lõpp-punktid, host[:port], eraldatuna komade või reavahetustega — vaikimisi port 6789.',
      pool: 'Kogum',
      poolHint: 'Tarbitav RBD-kogum — üks RBD-tõmmis ketta kohta.',
      fs: 'Failisüsteem',
      fsHint: 'CephFS-i failisüsteemi nimi (haakimisel mds_namespace).',
      fsPath: 'Tee failisüsteemi sees',
      fsPathHint: 'Absoluutne tee failisüsteemi sees, mille storage haagib — kahtluse korral /.',
      cephxCredential: 'Mandaat (cephx)',
      cephxCredentialHint: "Cephx-tüüpi keystore'i kirje: kasutajanimi = kliendi nimi (client.…), saladus = base64-võti. Kohustuslik.",
      cephxNone: 'Keystore\'is ei ole ühtegi cephx-mandaati — loo üks (tüüp: cephx) Süsteem → Mandaadid all või lase hallataval Ceph-klastril see vermida nupuga "Paku storage\'iks".',
      sharedByNature: 'Võrgu-storage\'id on olemuselt jagatud: iga liige haagib need samale TVirti hallatavale teele.',
      error: 'Storage lükati tagasi',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Muu',
        legacy: 'Legacy'
      },
      legacyHint: 'Igati toetatud — lihtsalt uue paigalduse jaoks me neid ei valiks.',
      proto: {
        // Rida `usage` (Luca 2026-07-24) ütleb, kuidas TVirt protokolli kasutab —
        // eelkõige lubatud sisu: dir/nfs/cifs majutavad kettaid NING ISO- ja
        // kettatõmmiseid ja template'eid, plokidraiverid (iscsi/nvme-tcp/rbd)
        // AINULT kettaid.
        dir: {
          name: 'Kohalik kaust',
          desc: 'Sõlme kataloog: lihtne ja kiire. See on ühe sõlme KOHALIK ressurss, kui tee ei ole tõeliselt jagatud share — selle jagatuks märkimine, kui ta seda ei ole, maksab andmeid.',
          usage: "TVirt hoiab siin VM-ide kettaid, ISO- ja kettatõmmiseid ning template'eid."
        },
        nfs: {
          name: 'NFS',
          desc: 'Klastri haagitud NFS-eksport — olemuselt jagatud.',
          usage: "Majutab VM-ide kettaid, ISO- ja kettatõmmiseid ning template'eid."
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Klastri haagitud Windowsi/Samba share — olemuselt jagatud.',
          usage: "Majutab VM-ide kettaid, ISO- ja kettatõmmiseid ning template'eid."
        },
        sftp: {
          name: 'SFTP',
          desc: 'Kaugfailisüsteem üle SSH — ilma NAS-eksporti vajamata.',
          usage: 'Teekaardil.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Plokk-LUN-id üle IP, peal jagatud LVM.',
          usage: "Ainult kettad — üks thin-köide ketta kohta; ei majuta ISO-tõmmiseid ega template'eid."
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Ceph-klastris hajutatud plokkseadmed.',
          usage: 'Ainult kettad — üks RBD-tõmmis ketta kohta, mille QEMU avab natiivselt; ISO-tõmmiseid ei majuta.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Ceph-i hajusfailisüsteem, mille kernel klastris haagib — olemuselt jagatud.',
          usage: "Majutab VM-ide kettaid, ISO- ja kettatõmmiseid ning template'eid — dir-pere Ceph-i failisüsteemi peal (cephx-mandaat kohustuslik)."
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUN-id FibreChanneli fabric-võrgus — klassikaline FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Seesama SCSI FibreChanneli peal, kus FC-raamid on kapseldatud Ethernetti.' },

        // Elus alates ringist #132 — võti on contracti draiveri nimi, nii et
        // storage'i loendi silt viitab samale kirjele.
        'iscsi-lun': {
          name: 'iSCSI (terved LUN-id)',
          desc: 'iSCSI sihtmärk tervete LUN-ide kandjana: iga ketas ON LUN, antud külalisele toorelt — ilma LVM-ita vahel.',
          usage: 'Ainult kettad — üks terve LUN ketta kohta, üle võetud nagu on; jagatud kirjutamisega ketaste SAN-kodu.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (terved nimeruumid)',
          desc: 'NVMe alamsüsteem tervete nimeruumide kandjana: iga ketas ON nimeruum, antud külalisele toorelt.',
          usage: 'Ainult kettad — üks terve nimeruum ketta kohta, üle võetud nagu on; jagatud kirjutamine jah, SCSI persistent reservations ei.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Kaug-NVMe — teel ei ole ühtegi SCSI-d — lihtsa TCP peal, peal jagatud LVM.',
          usage: "Ainult kettad — üks thin-köide ketta kohta; ei majuta ISO-tõmmiseid ega template'eid."
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Kaug-NVMe FibreChanneli fabric-võrgus.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe FibreChanneli fabric-võrgus, mida FCoE veab Etherneti sees — FCoE ja NVMe/FC kihid üksteise peal.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI, mille andmetee on tõstetud RDMA peale — ükskõik millises fabric-võrgus (InfiniBand, iWARP, RoCE). NVMe/RDMA on sellest üle astunud, kuid ta elab edasi massiivides ja ESXi-s.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: "Natiivne SCSI RDMA peal, iSER-i eelne ajastu: InfiniBand (koos fabric-võrgu avastusega) ja RoCE — elab edasi vanemates HPC-storage'ides." },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Kaug-NVMe ükskõik millises RDMA-fabric-võrgus — InfiniBand, iWARP, RoCE v1 ja v2: üksainus seadistus, sõlm ise ütleb, milline tal on.' },
        s3: { name: 'S3', desc: 'S3-ühilduv objekt-storage — tõmmised ja backupid.' }
      }
    },
    catalogs: {
      title: 'Kataloogid',
      createTitle: 'Loo kataloog',
      editTitle: 'Muuda kataloogi',
      docTitle: 'Kataloog',
      notFound: 'Seda kataloogi ei ole (enam?) olemas',
      scopeHint: "Kes seda scope'i loeb, näeb iga kataloogi faili (ja saab seda kasutada)",
      files: 'Failid',
      noFiles: 'Faile ei ole',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Püsivara'
      },

      // Süsteemi kataloog (ring #126): platvormi sisseehitatud objektide kodu —
      // kõigile loetav, mitte kellelegi kirjutatav.
      systemChip: 'süsteemne',
      systemTooltip: 'Süsteemi kataloog: majutab platvormi sisseehitatud objekte ja seda ei saa muuta'
    },

    // Kataloogifailid (ring K1, inventory v2e/v2g): kataloog on klastri
    // failiartefaktide kodu — üks loend, pealkirjad kindi kaupa.
    catalogFiles: {
      catalog: 'Kataloog',
      kindLabel: 'Tüüp',
      physicalSize: 'Füüsiline suurus',
      virtualSize: 'Virtuaalne suurus',

      // Ring K3 (#64) + K4 (#65, ova/ovf koos alglaadimise ellujäämise
      // vastendusega): materialiseerib vm-template faili inventari VM-templatena.
      importTemplateAction: "Impordi VM-template'ina",
      importTemplateLegacy: 'Vormingut ei ole deklareeritud — kasutatav ketaste seemnena, importida ei saa',
      importTemplateTitle: "Impordi VM-template'ina",
      importTemplateSubmit: 'Impordi',
      importTemplateError: 'Import ebaõnnestus',
      importTemplateHint: "Pakist .tvtpl saab VM-template: manifesti külmutatud riistvara pluss üks ketas arhiivi kirje kohta, igaüks oma kontrollsumma vastu kontrollitud. NIC-id ja CD/DVD-seadmed ei kuulu arhiivi — lisa need pärast importi.",
      importTemplateQcow2Hint: 'Paljast qcow2-st saab ÜHE kettaga template deklareeritud vaikeriistvaraga: profiil linux, UEFI, 2 vCPU, 2048 MiB, alglaadimine tema ainsalt kettalt. Paranda juurutamisel.',
      importTemplateName: "Template'i nimi",
      importTemplateNameHint: 'Tühi = {name} (-import-<n>, kui hõivatud)',
      importTemplateStorage: 'Ketaste storage',
      importTemplateMetadataStorage: 'Metaandmete storage',
      importTemplateMetadataHint: 'Plokk-storage ei majuta VM-i metaandmeid (püsivara, varstore) — vali mõni dir/nfs/cifs.',
      importTemplateStarted: "Import käivitatud — template ilmub Template'ite sakile, kui task sulgub.",

      // Kõnekad ainsuslikud sildid (#86): leiud ja loendus ütlevad, MIS fail
      // on — üldine 'Kataloogifail' jääb ainult varuvariandiks.
      kind: {
        iso: 'ISO-tõmmis',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI tõmmis',
        'firmware-ovmf': 'OVMF püsivara'
      },
      title: {
        iso: 'ISO-tõmmised',
        'ct-rootfs': "CT-template'id",
        'vm-template': "VM-template'id",
        'oci-image': 'OCI tõmmised',
        'firmware-ovmf': 'OVMF püsivara'
      },
      createTitle: {
        iso: 'Lisa ISO-tõmmis',
        'ct-rootfs': 'Registreeri CT-template',
        'vm-template': 'Lisa VM-template',
        'oci-image': 'Lisa OCI tõmmis',
        'firmware-ovmf': 'Lisa OVMF püsivara'
      },
      formatHint: 'Tuletatud valitud faili laiendist — paranda, kui pakkumine läks metsa',
      tarballHint: 'Rootfs-tarball standardses LXC vormingus (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 või lihtne .tar)',
      ociArchiveHint: 'docker-archive / oci-archive tarball (.tar või .tar.gz), näiteks docker save väljund',
      uploadResumeHint: 'Üleslaadimine katkes — fail ootab üleslaadimist: saada sama fail uuesti, et jätkata',
      moveTitle: 'Teisalda fail',
      moveHint: "Kaks sõltumatut mõõdet: Kataloog liigutab linki (sama id, ükski bait ei liigu, scope'iks saab sihtkataloogi oma); Storage liigutab andmeid — iga seotud koopia järgneb, kasutuses oleva faili puhul lükatakse tagasi. Koos valituna kõigepealt kataloog, siis storage.",
      moveCatalog: 'Sihtkataloog',
      moveCatalogHint: 'Ainult link vahetab kodu: faili ühendanud VM peab sihtkataloogi nägema',
      keepCurrent: 'Ära muuda',
      rehomed: 'Link liigutati valitud kataloogi',
      copyAction: 'Kopeeri kataloogi…',
      copyTitle: 'Kopeeri kataloogi',
      copyLinkHint: "Koopia on uus link samadele andmetele — storage'is ei dubleerita midagi.",
      copyCatalog: 'Sihtkataloog',
      copyCatalogHint: 'Kopeerimine ongi viis, kuidas fail kataloogide vahel rändab',
      sameCatalog: 'Sama mis lähtekohas',
      sharedObjectHint: 'Selle faili andmeid jagab {count} seotud koopiat',
      deleteLastLink: "See on selle sisu VIIMANE link: kustutatakse ka andmed storage'ist.",
      deleteLinkOnly: 'Eemaldatakse ainult see link — andmed jäävad alles, endiselt kättesaadavad teistest seotud koopiatest ({count}).',
      noCatalog: 'Ühtegi kataloogi ei ole — loo üks',
      inlineCatalogName: 'Kataloogi nimi',

      // Platvormi sisse ehitatud failid (ring #126): storage null — neid
      // loetakse ja kloonitakse, mitte kunagi ei teisaldata/kustutata/nimetata ümber.
      embeddedChip: 'sisseehitatud',
      embeddedStorage: 'Platvormi sisse ehitatud',
      embeddedNoMove: "Platvormi sisseehitatud fail: ei ela ühelgi storage'il — klooni see hoopis",
      embeddedCopyHint: "Kloonimine materialiseerib sisseehitatud baidid päris storage'ile: vali siht-storage ja -kataloog — koopia on tavaline fail",
      sourceEmbedded: 'Platvormi sisse ehitatud',
      nodesRow: 'Olemasolu sõlmede kaupa',
      nodesSummary: '{present} sõlme {total}-st omab seda',
      nodePresent: 'olemas',
      nodeMissing: 'puudub',
      nodeUnknown: 'veel teatamata',
      nodesHint: 'Vara elab iga sõlme kettal (pakett trantor-tvirt-assets): sõlm, millel seda pole, ei saa selle püsivaraga VM-i defineerida ega Guest Toolsi pakkuda. Erinevad versioonid sõlmede vahel on jooksva uuenduse ajal normaalsed.',

      // Allalaadimine (ring #108): baidid rändavad oma eraldi õigusega.
      downloadAction: 'Laadi alla',
      downloadNotReady: 'Sisu ei ole veel valmis — allalaadimine nõuab valmis faili',
      downloadDenied: 'Sinu roll ei sisalda õigust catalog.download — baitide allalaadimine on faili kasutamisest eraldi õigus',

      // Ring #156 (standarddialoog): üksikasjade dialoogi puuduvad lugemisread
      // — jagatud objekti faktid, deklareeritud kontrollsumma, kasutajad.
      objectRow: "Storage'i objekt",
      objectLinksRow: 'Seotud koopiad',
      declaredChecksum: 'Deklareeritud SHA-256',
      usedByRow: 'Kasutab',
      usedByVms: 'VM',
      usedByDisks: 'Kettad',
      transferRow: 'Ülekanne',
      storageLockHint: 'Muutub ainult tegevusega Teisalda'
    },

    // Storage'i-põhine loendus (ring K1, inventory v2b #2): ainult lugemiseks,
    // iga objekti hallatakse tema enda jaotisest.
    objects: {
      action: 'Uuri sisu',
      title: "Storage'i sisu",
      hint: "Ainult lugemiseks mõeldud ülevaade sellest, mis sellel storage'il elab — iga objekti hallatakse tema enda jaotisest.",
      empty: "Sellel storage'il ei ole ühtegi registreeritud objekti",
      loadError: 'Sisu ei õnnestunud laadida',
      colDetail: 'Üksikasi',
      manage: 'Halda tema enda jaotises',
      kind: {
        disk: 'Ketas',
        catalogFile: 'Kataloogifail',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-i metaandmed',
        appRoot: 'Rakenduse root',
        appVolume: 'Rakenduse köide'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloogid',
      storage: 'Storage',
      sizeGib: 'Suurus (GiB)',
      format: 'Vorming',
      size: 'Suurus',
      sourceType: 'Allikas',
      sourceFile: 'Faili üleslaadimine',
      sourceUrl: 'Allalaadimine URL-ilt',
      file: 'Fail',
      url: 'URL',
      checksum: 'Kontrollsumma SHA-256',
      checksumHint: 'Kohustuslik: allalaaditut kontrollitakse selle SHA-256 vastu',
      verifyChecksum: 'Kontrolli kontrollsummat',
      checksumOffHint: 'Allalaadimine võetakse vastu kontrollimata — arvutatud SHA-256 salvestatakse siiski',
      uploading: 'Üleslaadimine…',
      move: {
        action: 'Teisalda',
        diskTitle: 'Teisalda ketas',
        target: 'Siht-storage',
        diskHint: "Ketas säilitab oma identiteedi: baidid rändavad valitud storage'isse. Seda kasutav VM peab olema välja lülitatud; kui snapshot'e on, keeldub iSCSI teisaldamisest.",
        noTargets: "Ühilduvat siht-storage'it ei ole",
        submit: 'Teisalda',
        error: 'Teisaldamine lükati tagasi'
      },
      clone: {
        action: 'Klooni',
        title: 'Klooni ketas',
        name: 'Koopia nimi',
        storage: 'Siht-storage',
        sameStorage: 'Sama mis lähtekohas',
        linked: 'Linked clone',
        linkedHint: 'Hetkeline qcow2-overlay, mis on aheldatud lähteketta külge (ainult qcow2-lähtekettad). Vaikimisi tehakse täiskoopia.',
        linkedCrossHint: 'Linked clone jääb lähteketta storage\'ile: selle lubamiseks vali "Sama mis lähtekohas".',
        submit: 'Klooni',
        error: 'Kloonimine lükati tagasi'
      },
      copy: {
        action: 'Kopeeri',
        name: 'Koopia nimi',
        storage: 'Siht-storage',
        sameStorage: 'Sama mis lähtekohas',
        submit: 'Kopeeri',
        error: 'Kopeerimine lükati tagasi'
      },
      taskStarted: 'Käivitatud — jätkub taustal taskina',
      cephObjects: 'Vaata objekti üksikasju Cephis',
      phase: {
        ready: 'Valmis',
        creating: 'Loomisel',
        'awaiting-upload': 'Ootab üleslaadimist',
        downloading: 'Allalaadimisel',
        verifying: 'Kontrollimisel',
        deleting: 'Kustutamisel',
        error: 'Viga',
        'in-use': 'Kasutuses'
      }
    }
  }
}
